import * as React from "react";
import { observer } from "mobx-react-lite";
import * as styles from "./style.module.css";
import { Button } from "react-bootstrap";
import I18n from "lib/I18n";
import { ToolUse } from "bundles/BigqueryQueryViewer/store/chat";

interface YesNoProps {
  toolUse: ToolUse;
  isLast: boolean;
  onToolResponse: (tool: ToolUse, response: unknown) => void;
}

export const YesNo = observer((props: YesNoProps) => {
  const { toolUse, isLast, onToolResponse } = props;

  return (
    <div className={styles.root}>
      {(["yes", "no"] as const).map((choice, i) => (
        <Button
          variant="outline-primary"
          size="sm"
          key={i}
          className={styles.button}
          disabled={!isLast}
          onClick={() => onToolResponse(toolUse, { choice })}
        >
          {I18n.t(`bigquery_query_viewer.label.${choice}`)}
        </Button>
      ))}
    </div>
  );
});
